<div class="platform-section-container">
    <h1 class="solcitare-title">Editare secțiune platformă</h1>
    <form class="platform-section-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="platform-section-nume">
            <mat-form-field appearance="fill">
                <mat-label>Nume</mat-label>
                <input type="text" matInput formControlName="name">
            </mat-form-field>
            <mat-error *ngIf="!form.controls['name'].valid && form.controls['name'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>
        <div class="platform-section-slug">
            <mat-form-field appearance="fill">
                <mat-label>Slug</mat-label>
                <input type="text" matInput formControlName="slug">
            </mat-form-field>
            <mat-error *ngIf="!form.controls['slug'].valid && form.controls['slug'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>
        <div class="platform-section-observations">
            <mat-form-field appearance="fill">
                <mat-label>Observații</mat-label>
                <input type="text" matInput formControlName="observations">
            </mat-form-field>
            <mat-error *ngIf="!form.controls['observations'].valid && form.controls['observations'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>

        <div class="spinner"><mat-spinner *ngIf="isLoading"></mat-spinner></div>
        <div class="platform-section-action-btns">
            <button type="button" class="buttons" mat-flat-button (click)="closeDialog()">Close</button>
            <button class="buttons" mat-flat-button color="primary" type="submit">Save</button>
        </div>
    </form>
</div>
